import React from "react";

const FormError = ({ children }) => {
  return (
    <small style={{ color: "tomato", textAlign: "center" }}>{children}</small>
  );
};

export default FormError;
